module.exports = __webpack_public_path__ + "static/media/pdf-icon.1ee918e1.svg";